import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { PasswordRecoveryService, SecretData, SelectedVerificationMethodInfo } from 'src/app/shared/services/password-recovery.service';
import { TipoAlteracaoPerfilEnum } from '../selecao-canal-validacao-page/selecao-canal-validacao-page.component';
import { TipoValidacaoCadastral } from 'src/app/shared/components/validacao-cadastro-modal/validacao-cadastro-modal.component';

@Component({
  selector: 'app-profile-token-confirmation-page',
  templateUrl: './profile-token-confirmation-page.component.html',
  styleUrls: ['./profile-token-confirmation-page.component.scss']
})
export class ProfileTokenConfirmationPageComponent implements OnInit {

  verificationMethodInfo: SelectedVerificationMethodInfo | null;
  isMinorThanTablet: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');
  tipoAlteracao: TipoAlteracaoPerfilEnum;

  formTitle = {
    [TipoAlteracaoPerfilEnum.EMAIL]: 'Alterar e-mail',
    [TipoAlteracaoPerfilEnum.SENHA]: 'Cadastrar nova senha',
    [TipoAlteracaoPerfilEnum.TELEFONE]: 'Alterar celular',
  }

  constructor(
    private passwordRecoveryService: PasswordRecoveryService,
    private router: Router,
    private location: Location,
    public breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.setRouterParameterSubscribe();
    this.verificationMethodInfo = this.passwordRecoveryService.getSelectedVerificationMethodInfo();
    this.passwordRecoveryService.clearSecretKey();

    if (!this.verificationMethodInfo) {
      this.router.navigate(['/portal/perfil']);
      return;
    }
  }

  setRouterParameterSubscribe() {
    return this.route.params.subscribe(({ tipoAlteracao }) => {
      const isParamValid = Object.values(TipoAlteracaoPerfilEnum).includes(tipoAlteracao);
      if (!isParamValid) {
        this.location.back();
      }

      this.tipoAlteracao = tipoAlteracao;
    });
  }

  handleConfirmToken(secretData: SecretData) {
    if (secretData) {
      this.passwordRecoveryService.setSecretKey(secretData);

      if (this.tipoAlteracao === TipoAlteracaoPerfilEnum.SENHA) {
        return this.router.navigate(['portal/perfil/alterar/senha'], { state: { isValidationAllowed: true } });
      }

      const updateModalType = this.tipoAlteracao === TipoAlteracaoPerfilEnum.EMAIL ? TipoValidacaoCadastral.EMAIL : TipoValidacaoCadastral.PHONE;
      this.router.navigate(['portal/perfil'], { state: { showUpdateProfileModal: updateModalType } });
    }
  }

  get pathToRedirectOnError() {
    if (this.tipoAlteracao === TipoAlteracaoPerfilEnum.SENHA) {
      return 'portal/perfil';
    }

    return `portal/perfil/alterar/${this.tipoAlteracao.toLowerCase()}/confirmar-conta`;
  }

  get enableVerificationAccount() {
    return this.tipoAlteracao !== TipoAlteracaoPerfilEnum.SENHA;
  }

  handleGoBack() {
    this.location.back();
  }

}
